import { MARKER_SELECTED_STROKE_COLOR } from './constants'
import { MarkerTypes } from 'Modules/types/pages/imageReview/enums'
import {
  handleAnnotationSelected,
  handleAnnotationDeselected,
  handleAnnotationMouseEnter,
  handleAnnotationMouseLeave,
  handleAnnotationCreated,
  handleAnnotationEdit,
} from './markerDefectEventHandlers'
import {
  handleMeasurementCreate,
  handleMeasurementSelected,
  handleMeasurementDeselected,
  handleMeasurementMouseEntered,
  handleMeasurementMouseLeave,
  handleMeasurementEdit,
} from './markerMeasurementEventHandlers'

/**
 * Triages the event to the defect or measurement event
 * handler based on if the marker corresponds with an
 * defect annotation or a measurment
 * @param markerEvent
 * @param defectCallback
 * @param measurementCallback
 */
function markerEventTriage(
  markerEvent,
  defectCallback: (markerEvent) => void,
  measurementCallback: (markerEvent) => void
) {
  const marker = markerEvent.marker
  const isMeasurement = marker.state.meta?.isMeasurement

  if (!isMeasurement) {
    defectCallback(markerEvent)
  } else {
    measurementCallback(markerEvent)
  }
}

/**
 * Callback function to be triggered when a marker has just been created
 * @param markerEvent MarkerArea MarkerEvent type
 * @param setMode callback function to set the mode of ImageInspector
 */
function markerCreatedCallback(markerEvent): void {
  const marker = markerEvent.marker

  //TODO Enhancement, allow create marker to be created with a default meta props
  //so we do not have to rely on marker type to assigning isMeasurement based on markertype
  if (marker.typeName === MarkerTypes.Measurement) {
    marker.state.meta = {
      ...marker.state.meta,
      isMeasurement: true,
    }
  }

  markerEventTriage(markerEvent, handleAnnotationCreated, handleMeasurementCreate)
}

/**
 * Callback function to be triggered when a marker is selected
 * @param markerEvent MarkerArea MarkerEvent type
 * @returns void
 */
function markerSelectedCallback(markerEvent) {
  const marker = markerEvent.marker
  marker.state.strokeColor = MARKER_SELECTED_STROKE_COLOR

  markerEventTriage(markerEvent, handleAnnotationSelected, handleMeasurementSelected)
}

/**
 * Callback function to be triggered when a marker is deselected
 * @param markerEvent MarkerArea MarkerEvent type
 * @returns void
 */
function markerDeselectedCallback(markerEvent): void {
  markerEventTriage(markerEvent, handleAnnotationDeselected, handleMeasurementDeselected)
}

/**
 * Callback function to be triggered when a users mouse enters the markers bounds
 * @param markerEvent MarkerArea MarkerEvent type
 * @returns void
 */
function markerMouseEnteredCallback(markerEvent): void {
  markerEventTriage(markerEvent, handleAnnotationMouseEnter, handleMeasurementMouseEntered)
}

/**
 * Callback function to be triggered when the users mouse leaves the markers bounds
 * @param markerEvent MarkerArea MarkerEvent type
 * @returns void
 */
function markerMouseLeaveCallback(markerEvent): void {
  markerEventTriage(markerEvent, handleAnnotationMouseLeave, handleMeasurementMouseLeave)
}

/**
 * Callback function to be triggered when the markers state has been edited
 * @param markerEvent MarkerArea MarkerEvent type
 * @returns void
 */
//TODO add typings to params
function markerEditCallback(markerEvent): void {
  markerEventTriage(markerEvent, handleAnnotationEdit, handleMeasurementEdit)
}

export {
  markerCreatedCallback,
  markerSelectedCallback,
  markerDeselectedCallback,
  markerMouseEnteredCallback,
  markerMouseLeaveCallback,
  markerEditCallback,
}
